import Api from '../../api'
import { takeLatest, call, put } from 'redux-saga/effects'
import createRequestSaga from 'portal-modules/common/redux/create-request-saga'
import { requestAmenitiesList } from './amenities'

// action types
export const REQUEST_UPCOMING_RESERVATION_LIST =
  'ep/reservations/REQUEST_UPCOMING_RESERVATION_LIST'
export const RECEIVE_UPCOMING_RESERVATION_LIST =
  'ep/reservations/RECEIVE_UPCOMING_RESERVATION_LIST'
export const DELETE_UPCOMING_RESERVATION_LIST =
  'ep/reservations/DELETE_UPCOMING_RESERVATION_LIST'
export const UPCOMING_RESERVATION_DELETED =
  'ep/reservations/UPCOMING_RESERVATION_DELETED'

// action creators
export const requestUpcomingReservationsList = () => ({
  type: REQUEST_UPCOMING_RESERVATION_LIST,
})

export const deleteUpcomingReservation = payload => ({
  type: DELETE_UPCOMING_RESERVATION_LIST,
  payload,
})

// reducer
export default (state = {}, { payload, type }) => {
  switch (type) {
    case RECEIVE_UPCOMING_RESERVATION_LIST:
      return { ...payload }
    case UPCOMING_RESERVATION_DELETED:
      return Object.values(state).filter(({ id }) => id != payload)

    default:
      return state
  }
}

// sagas
export function* getUpcomingUpcomingReservationsList() {
  const { reservations } = yield call(Api.requestUpcomingAmenities)
  if (reservations && reservations.length) {
    yield put({
      type: RECEIVE_UPCOMING_RESERVATION_LIST,
      payload: reservations.reduce(
        (obj, currentVal) => ({
          ...obj,
          [currentVal.id]: {
            ...currentVal,
          },
        }),
        {},
      ),
    })
  }
}

export function* watchRequestUpcomingReservations() {
  yield takeLatest(
    REQUEST_UPCOMING_RESERVATION_LIST,
    createRequestSaga(getUpcomingUpcomingReservationsList, {
      key: 'reservations',
      message: __('Getting Upcoming Reservations'),
    }),
  )
}

export function* handleDeleteUpcomingReservation({ payload }) {
  yield call(Api.deleteReservation, { id: payload })
  yield put(requestAmenitiesList())
  yield put({ type: UPCOMING_RESERVATION_DELETED, payload })
}

export function* watchDeleteReservation() {
  yield takeLatest(
    DELETE_UPCOMING_RESERVATION_LIST,
    createRequestSaga(handleDeleteUpcomingReservation, {
      key: 'amenities',
      message: __('Cancelling your reservations'),
      successMessage: __('Reservation successfully cancelled'),
      write: true,
    }),
  )
}

export const sagas = [watchRequestUpcomingReservations, watchDeleteReservation]
